import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { saleProductSelector } from '../../../../../selectors'
import { Input } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { formatNumber } from '../../../../../function/math'

export const hardware_type = [
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'MA', value: 'HARDWARE_MA' },
]

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

export const InputRow = (props) => {
  const [saleProducts, setSaleProducts] = useState([])
  const _saleProducts = useSelector(saleProductSelector.getSaleProductList)
  const {
    idx,
    hardware,
    handleInput,
  } = props

  useEffect(() => {
    setSaleProducts(_saleProducts.map(p => {
      return {
        label: p.name,
        value: p._id,
      }
    }))
  }, [_saleProducts])

  const type = hardware_type.find(t => t.value === hardware.type)
  const saleProduct = saleProducts.find(p => p.value === hardware.product_id)
  const creditTerm = credit_term.find(t => t.value === hardware.credit_term)

  return (
    <Root>
      <Text>{ type ? type.label : '-' }</Text>
      <Text>{ saleProduct ? saleProduct.label : '-' }</Text>
      <InputWrapper>
        <Input
          name='sub_project_code'
          placeholder='Enter Sub-proj. Code'
          value={ hardware.sub_project_code }
          onChange={ e => handleInput({ hardware_id: hardware.hardware_id, sub_project_code: e.target.value }, 'hardwares', idx) }
        />
      </InputWrapper>
      <Text>{ hardware.description || '-' }</Text>
      <Text>{ hardware.delivery_date ? moment(hardware.delivery_date).format('DD/MM/YYYY') : '-' }</Text>
      <Text>{ creditTerm ? creditTerm.label : '-' }</Text>
      <Number>{ formatNumber(hardware.cost) || '-' }</Number>
      <Number>{ formatNumber(hardware.price) || '-' }</Number>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 3fr 3fr 3fr 4fr 3fr 2fr 3fr 3fr;
  padding: 0 24px;
  background: #FFFFFF;
  margin-top: 1px;

  :nth-child(1) {
    margin: 0;
  }
`

const InputWrapper = styled.div`
  position: relative;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`

const Number = styled(Text)`
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-hardware/input-row.js